import { detailFieldStyles } from '@v2/components';

export const styles = {
  wrapper: 'tw-flex tw-flex-col tw-gap-4',
  fieldGrid: detailFieldStyles.fieldContainer,
  toggleRow: 'tw-flex tw-items-center tw-gap-3 tw-py-2',
  selectWrapper: 'tw-w-full',
};
